;(function() {
  'use strict'

  Service.$inject = ["$q", "colors", "zonePageService"];
  angular.module('core.services').factory('zoneService', Service)

  /* @ngInject */
  function Service($q, colors, zonePageService) {
    var Defaults = {
      title: null,
      tagline: 'Ready to share your opinion?',
      productInstructions: 'Enter the last 5 digits of the barcode.',
      buttonBackgroundColor: colors.Colors.GREY_INDIFFERENT,
      inputBorderColor: colors.Colors.GREY_SOFT,
    }
    var Themes = {
      glow: {
        businessCTA: true,
        buttonBackgroundColor: colors.Colors.ORANGE_SEA_BUCKTHORN,
      },
    }

    return {
      getTheme: getTheme,
    }

    function getTheme(themeName) {
      return $q(function(resolve, reject) {
        if (Themes[themeName]) {
          resolve(_.defaults({}, Themes[themeName], Defaults))
        } else {
          zonePageService
            .getTheme(themeName)
            .then(function(theme) {
              resolve(_.defaults({}, theme, Defaults))
            })
            .catch(reject)
        }
      })
    }
  }
})()
